import "../styles/billing.css";

function Placeholder() {
  // Placeholder UI gives a fast canvas for invoice/payment UX decisions.
  return (
    <section className="feature-shell">
      <h2>Billing Feature</h2>
      <p>Use this space to sketch invoices, subscriptions, and payment states.</p>
    </section>
  );
}

export default Placeholder;
